import { useState } from "react";

import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_OPTIONS,
} from "static/pagination";

/**
 * Use page size options hook to get pageSize options and save pageSize in local storage if needed
 *
 * @param {number} pageSize
 * @param {array} pageSizeOptions
 * @returns {array} [pageSize, setPageSize, pageSizeOptions]
 */
const useCustomTablePageSizeOptions = (
  pageSize = DEFAULT_PAGE_SIZE,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS
) => {
  const [currentPageSize, setCurrentPageSize] = useState(pageSize);

  const changePageSize = (newPageSize) => {
    setCurrentPageSize(newPageSize);
  };

  return [currentPageSize, changePageSize, pageSizeOptions];
};

export default useCustomTablePageSizeOptions;
